import React from 'react';
import { TableActionBar } from '@/components/table';

type Props = {
  url?: string | null;
  onCopy?: () => void;
  onResend?: () => void;
  resending?: boolean;
  resendDisabled?: boolean;
  resendTitle?: string;
  onRetry?: () => void;
  retrying?: boolean;
  retryDisabled?: boolean;
  retryTitle?: string;
  children?: React.ReactNode;
};

export default function TableRowActions({
  url,
  onCopy,
  onResend,
  resending = false,
  resendDisabled = false,
  resendTitle = 'Resend listing message',
  onRetry,
  retrying = false,
  retryDisabled = false,
  retryTitle = 'Retry failed delivery via send worker',
  children,
}: Props) {
  return (
    <TableActionBar>
      {url && (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="btn btn-sm btn-ghost"
          aria-label="Open listing in new tab"
        >
          Open
        </a>
      )}
      {onCopy && (
        <button type="button" className="btn btn-sm btn-ghost" onClick={onCopy} aria-label="Copy URL">
          Copy
        </button>
      )}
      {onRetry && (
        <button
          type="button"
          className="btn btn-sm"
          disabled={retryDisabled || retrying}
          title={retryTitle}
          aria-label={retrying ? 'Retrying' : 'Retry'}
          onClick={onRetry}
        >
          {retrying ? 'Retrying…' : 'Retry'}
        </button>
      )}
      {onResend && (
        <button
          type="button"
          className="btn btn-sm"
          disabled={resendDisabled || resending}
          title={resendTitle}
          aria-label={resending ? 'Sending' : 'Resend'}
          onClick={onResend}
        >
          {resending ? 'Sending…' : 'Resend'}
        </button>
      )}
      {children}
    </TableActionBar>
  );
}
